<template>
	<div class="followup">

		<div class="collapse-wrap" v-if="recordId == ''">
			<div class="search-bar">
				<el-form ref="form" label-width="120px">
					<div class="def-key">
						<label>结算时间
							<el-date-picker size="small" :default-time="['00:00:00', '23:59:59']" style="width:220px" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" v-model="filter.date" :picker-options="pickerOptions" @change="handleFilter(0, $event)"></el-date-picker>
						</label>
						<label>诊断
							<el-input size="small" style="width:80px" v-model.trim="filter.diagnosis" @keyup.enter.native="handleFilter(1, $event)"></el-input>
						</label>
						<div style="display: inline-block;">来源
							<el-select size="small" filterable clearable v-model="filter.dataSource" placeholder="请选择" @change="handleFilter(2, $event)">
								<el-option label="门诊" :value="1"></el-option>
								<el-option label="院中" :value="0"></el-option>
								<el-option label="出院" :value="2"></el-option>
							</el-select>
						</div>
						<el-button class="flr" size="mini" icon="el-icon-search" round @click="handleFilter">搜索</el-button>

					</div>
				</el-form>
			</div>

			<div class="table-wrap">
				<el-button  style="margin-bottom:20px" type="primary" size="mini"  v-if="addRecordRule" round @click="showDlg">添加就诊记录</el-button>

				<el-table ref="multipleTable"  header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
					<el-table-column prop="recordTime" label="结算时间" width="120"></el-table-column>
					<el-table-column label="来源" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.datasources == 0">院中</span>
							<span v-if="scope.row.datasources == 1">门诊</span>
							<span v-if="scope.row.datasources == 2">出院</span>
						</template>
					</el-table-column>
					<el-table-column prop="department" label="科室" width="180"></el-table-column>
					<el-table-column prop="diagnosis" label="诊断"></el-table-column>
					<el-table-column prop="mainDoctor" label="责任医师" width="120"></el-table-column>
					<el-table-column label="类型" width="120">
						<template slot-scope="scope">
							<span v-if="scope.row.autoState == 0">自动抓取</span>
							<span v-if="scope.row.autoState == 1">手动添加</span>
						</template>
					</el-table-column>

					<el-table-column label="操作" width="120">
						<template slot-scope="scope">
							<div class="tab-action">
								<el-tooltip content="查看" placement="top" :enterable="false"><router-link :to="{name: 'Patient/User', query: {patientId: patientId, t:3, fid: scope.row.id,datasources: scope.row.datasources}}"><i class="icon-research"></i></router-link></el-tooltip>
								<!-- <el-tooltip content="同步" placement="top" :enterable="false"><i class="icon-sync"></i></el-tooltip> -->
							</div>
						</template>
					</el-table-column>
					
				</el-table>	
				<div class="pagination">
					<el-row>
						<el-col :span="12">
							<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="Math.min(list.total, (filter.pageNumber - 1) * filter.pageSize + filter.pageSize)"></span>数据</div>
							<div class="record">总计<span v-text="list.total"></span>条记录</div>
						</el-col>
						<el-col :span="12" style="text-align: right;">
							<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
						</el-col>
					</el-row>
				</div>
			</div>				
				
		</div>
		
		<template v-if="recordId != ''">
		<div class="info">
			<div class="info-date">
				<div v-if="itemDetail.datasources == 2"><span class="fc key">就诊记录</span> / {{itemDetail.outHospitalTime}}</div>
				<div v-else><span class="fc key">就诊记录</span> / {{itemDetail.inHospitalTime}}</div>

				<el-button type="primary" size="mini" plain round @click="backToList">历史就诊记录</el-button>
			</div>
			<div class="sub-title">就诊信息</div>

			<el-row :gutter="20">
				<el-col :span="5">来源：{{itemDetail.source}}</el-col>
				<el-col :span="5">就诊科室：{{itemDetail.department}}</el-col>
				<el-col :span="5" v-if="itemDetail.datasources == 1">就诊号：{{itemDetail.admissionNumber}}</el-col>
				<el-col :span="5" v-else>住院号：{{itemDetail.admissionNumber}}</el-col>
				<el-col :span="5" style="display: flex; align-items: center;" v-if="wxQrflag">二维码&nbsp;
					<el-tag size="small" type="danger" v-if="patientInfo.wxBindingState == 0">未绑定</el-tag>
					<el-tag size="small" type="success" v-if="patientInfo.wxBindingState == 1">已绑定</el-tag>
					：
					<img src="../../../assets/images/qr-code-fill.png" style="width: 28px; height: 28px; cursor: pointer;" @click="viewQr">
				</el-col>
			</el-row>

			<el-row :gutter="20">
				<el-col :span="5" v-if="itemDetail.datasources == 0">入院时间：{{itemDetail.inHospitalTime}}</el-col>
				<el-col :span="5" v-if="itemDetail.datasources == 1">就诊时间：{{itemDetail.outHospitalTime}}</el-col>
				<el-col :span="5" v-if="itemDetail.datasources == 2">入院时间：{{itemDetail.inHospitalTime}}</el-col>
				<el-col :span="5" v-if="itemDetail.datasources == 2">出院时间：{{itemDetail.outHospitalTime}}</el-col>
				<el-col :span="5" v-if="itemDetail.datasources == 0">病区：{{itemDetail.inpatientArea}}</el-col>
				<el-col :span="5" v-if="itemDetail.datasources == 0">床号：{{itemDetail.hospitalBed}}</el-col>
				
				<el-col :span="5">电子病历：<a class="round primary" target="_blank" :href="itemDetail.emrUrl"><i class="icon-view"></i>查看</a></el-col>
				<el-col :span="5" v-if="emrUrl1.flag&&itemDetail.emrUrl1">{{ emrUrl1.name }}：<a class="round primary" target="_blank" :href="itemDetail.emrUrl1"><i class="icon-view"></i>查看</a></el-col>
			</el-row>

			<el-row :gutter="20" style="display:flex;">
				<el-col :span="5">责任医师：{{itemDetail.mainDoctor}}</el-col>
				<el-col :span="5" v-if="itemDetail.datasources != 1">入院方式：{{itemDetail.inHospitalType}}</el-col>
				<el-col :span="5" v-if="itemDetail.hospitalizationTimes" style="float: none;">入院次数：{{itemDetail.hospitalizationTimes}}</el-col>
			</el-row>
			<div class="result">
				<div class="t" style="display: flex;align-items: center;">{{ itemDetail.datasources == 0?'入院':itemDetail.source }}诊断：
					<el-tag class="round" size="mini" type="danger" v-text="item.tagName"
						v-for="item in itemDetail.diagnosisTags" :key="item.tagId"></el-tag>
				</div>
				<div class="">{{itemDetail.diagnosisName}}</div>
			</div>
			<div class="result" v-if="itemDetail.surgeryName">
				<div class="t" style="display: flex;align-items: center;">手术：
					<el-tag class="round" size="mini" type="danger" v-text="item.tagName"
						v-for="item in itemDetail.surgeryTags" :key="item.tagId"></el-tag>
				</div>
				<div class="">{{itemDetail.surgeryName}}</div>
			</div>
		</div>
		
		<el-tabs class="customize tab-divide" @tab-click="handleTab" v-model="currentTab" lazy="true">
				<el-tab-pane label="院中管理" name="t1" class="bg-w" v-if="datasources != 1">
					<tab1 ref="info_t1" :patientId="patientId" :customerId="customerId" :datasources="datasources" :recordId="recordId" :onEvalShow="onEvalShow" @openUserFollowup4="openUserFollowup4" :patient="patient"></tab1>
				</el-tab-pane>
				<el-tab-pane label="六大处方" name="t4" class="bg-w">
					<tab4 ref="info_t4" :patientId="patientId"  :patientInfo='patientInfo' :customerId="customerId"  :datasources="datasources" :recordId="recordId" :onEvalShow="onEvalShow" :type="typeT"></tab4>
				</el-tab-pane>
				<el-tab-pane label="排期管理" name="t2" class="bg-w" v-if="datasources != 0">
					<tab2 ref="info_t2" :dataId="itemDetail.dataId"></tab2>
				</el-tab-pane>
				<el-tab-pane label="复诊计划" name="t3" class="bg-w" v-if="datasources != 0">
					<tab3 ref="info_t3"></tab3>
				</el-tab-pane>
				<el-tab-pane name="t5" class="bg-w" style="border: none;" v-if="datasources == 0">
					<span slot="label">
						管理沟通
						<div v-show="noReadNum > 0" style="border-radius: 50%;background-color: #FF6C6C;position: absolute;right: -14px;top: 5px;font-size: 1pt;text-align: center;line-height: 15px;width: 15px;height: 15px;color: #fff;">{{noReadNum}}</div>
					</span>
					<tab5 ref="info_t5" :patientId="patientId" :customerId="customerId"  :recordId="recordId" :mainDoctorId="this.itemDetail.mainDoctorId" :diseaseManagerId ="this.itemDetail.diseaseManagerId "></tab5>
				</el-tab-pane>
				<el-tab-pane label="延续性护理服务" name="t6" class="bg-w" v-if="datasources == 0&&(hospitalCode=='SD_ZQ1'||hospitalCode=='YS_HM4'||hospitalCode=='SD_TA2')">
					<tab6 ref="info_t2"></tab6>
				</el-tab-pane>
		</el-tabs>
		</template>
		<el-dialog
			:visible.sync="dialogVisible"
			width="819px"
			:close-on-click-modal="false"
			@close="closeDia"
			>
			<div style="display: flex;justify-content: center;align-items: center;flex-direction: column;" v-if="imgData">
				<div class="topTips">
					<div class="left"><span>{{ itemDetail.hospitalBed }}</span> 床</div>
					<div class="middle">
						<p>{{ itemDetail.patientName }}</p>
						<p>{{ patientInfo.sex == 1 ? '男' : '女' }} {{ patientInfo.age }}岁</p>
					</div>
					<div class="rig">
						<el-tag type="danger" v-if="patientInfo.wxBindingState == 0">未绑定</el-tag>
						<el-tag type="success" v-if="patientInfo.wxBindingState == 1">已绑定</el-tag>
					</div>
				</div>
				<p style="margin-bottom: 20px;">请使用微信扫码，可以填写评估问卷</p>
				<div ref="qrcode" style="margin-bottom: 24px;"></div>
				
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="downloadQRCode">下 载</el-button>
				<el-button @click="closeDia">取 消</el-button>
			</span>
		</el-dialog>
		<el-dialog
			:visible.sync="dlg.active"
			title="添加就诊记录"
			width="640px"
			:close-on-click-modal="false"
			@close="closeDia"
			class='cenDialog'
			>
			<el-form ref="form1" label-width="180px" :rules="dlg.rules" :model="form1">
				<el-form-item label="所属医院" prop="orgId">
					<el-select size="small" v-model="form1.orgId" placeholder="请选择医院">
						<el-option v-for="(item,index) in orgList" :key="index" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item label="就诊类型" prop="datasources">
					<el-select size="small" v-model="form1.datasources" placeholder="请选择就诊类型" >
						<el-option v-for="(item,index) in dataSourceList" :label="item.label" :value="item.value" :key="index"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="就诊科室" prop="departmentId">
					<el-select size="small"  v-model="form1.departmentId" placeholder="请输入住院科室">
						<el-option v-for="item in deptList"  style="width: 300px;" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="责任医师" prop="mainDoctorId">
					<el-select size="small" v-model="form1.mainDoctorId" placeholder="请输入科室医生">
						<el-option v-for="item in mainList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>

				<el-form-item :label="form1.datasources==1?'就诊号':'住院号'" prop="admissionNumber">
					<el-input size="small" v-model.trim="form1.admissionNumber" placeholder="请输入住院号"></el-input>
				</el-form-item>
				<template v-if='form1.datasources==0'>
					<el-form-item label="床号" prop="hospitalBed">
						<el-input size="small" v-model.trim="form1.hospitalBed" placeholder="请输入病床号"></el-input>
					</el-form-item>
					<el-form-item label="病区" prop="inpatientArea">
						<el-input size="small" v-model.trim="form1.inpatientArea" placeholder="请输入病区"></el-input>
					</el-form-item>
				</template>
				<el-form-item label="入院次数" prop="hospitalizationTimes">
					<el-input size="small" v-model.number="form1.hospitalizationTimes" placeholder="请输入入院次数"></el-input>
				</el-form-item>
				<el-form-item label="诊断" prop="baseAuxDiagDiscr">
					<el-radio-group v-model="form1.baseAuxDiagDiscr">
					<el-radio label="1">主诊断</el-radio>
					<el-radio label="2">副诊断</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="ICD编码" prop="diagnosisList">
					<el-select v-model="icd.value" size="small" filterable remote reserve-keyword placeholder="请输入关键词" :loading="icd.loading" :remote-method="onLoadIcd">
						<el-option v-for="item in icd.source" :key="item.icdId" :label="item.icdName" :value="item.icdId"></el-option>
					</el-select>

					<el-button type="primary" size="mini" style="margin-left: 10px;" :loading="isLoading" @click="onAddIcd">添加</el-button>
				</el-form-item>
				<el-form-item label="" style="margin-top: 21px;">
					<el-table ref="multipleTable" max-height="600" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="icd.list" v-loading="isLoading">
						<el-table-column prop="icdCode" label="ICD编码"></el-table-column>
						<el-table-column prop="icdName" label="ICD名称"></el-table-column>
						<el-table-column label="操作" width="60" align="center">
							<template slot-scope="scope">
								<div class="tab-action">
									<el-tooltip content="删除" placement="top" :enterable="false"><i class="el-icon-delete" @click="onRemoveIcd(scope.row)"></i></el-tooltip>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</el-form-item>
				<template v-if="form1.datasources==1">

					<el-form-item label="就诊时间" prop="inHospitalTime">
						<el-date-picker
						size="small"
						v-model="form1.inHospitalTime"
						type="datetime"
						placeholder="请输入就诊时间"
						value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
					</el-form-item>
				</template>
					<el-form-item v-if="form1.datasources!=1" label="入院时间" prop="inHospitalTime">
						<el-date-picker
						size="small"
						v-model="form1.inHospitalTime"
						type="datetime"
						placeholder="请输入入院时间"
						value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
					</el-form-item>
					<el-form-item v-if="form1.datasources==2" label="出院时间" prop="outHospitalTime">
						<el-date-picker
						size="small"
						v-model="form1.outHospitalTime"
						type="datetime"
						placeholder="请输入出院时间"
						value-format="yyyy-MM-dd HH:mm:ss">
						</el-date-picker>
					</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer cenFooter">
				<el-button type="primary" @click="addRecordHandle" v-loading.fullscreen.lock="addLoading">添 加</el-button>
				<el-button @click="closeDia">取 消</el-button>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';
import dayjs from 'dayjs';
//import Tab1 from './user-followup-1.vue';
import Tab1 from './user-followup-1_new.vue';
import Tab2 from './user-followup-2.vue';
import Tab3 from './user-followup-3.vue';
import Tab4 from './user-followup-4.vue';
import Tab5 from './user-followup-5.vue';
import Tab6 from './user-followup-6.vue';

 
//所需页面导入
import QRCode from 'qrcodejs2'

export default {
	components: {Tab1, Tab2, Tab3, Tab4, Tab5,Tab6},
	mixins: [mixin],
	props:{
		onEvalShow:{
			type: Function,
			default: null
		},
		type:{
			required: true
		},
		customerId:{required: true},
		patient:{required: true},
	},
	data(){
		return {
			noSidebar: true,
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				patientId: 0,
				recordTimeStart: '',
				recordTimeEnd: '',
				diagnosis: '',
				datasources: '',
				pageNumber: 1,
				pageSize: 10
			},
			patientId: 0,
			currentTab: 't1',
			recordId: '',
			itemDetail: {},
			noReadNum:0,
			typeT:this.type,
			datasources:0,
			hospitalCode:'YS_HM4',
			emrUrl1:{},//第二个电子病历
			dialogVisible:false,
			imgData: false,
			patientInfo:{},
			wxQrflag:false,
			dlg:{
				active:false,
				rules: {
					orgId: [{ required: true, message: '请选择所属医院', trigger: 'change' }],
					datasources: [{ required: true, message: '请选择就诊类型', trigger: 'change' }],
					departmentId: [{ required: true, message: '请选择就诊科室', trigger: 'change' }],
					mainDoctorId: [{ required: true, message: '请选择责任医师', trigger: 'change' }],
					admissionNumber: [{ required: true, message: '请输入住院号', trigger: 'blur' }],
					hospitalizationTimes: [{ required: true, message: '请输入入院次数', trigger: 'blur' }],
					baseAuxDiagDiscr: [{ required: true, message: '请选择诊断', trigger: 'change' }],
					outHospitalTime: [{ required: true, message: '请选择出院时间', trigger: 'change' }],
					inHospitalTime: [{ required: true, message: '请选择出院时间', trigger: 'change' }],
					diagnosisList: [{ required: true, message: '请选择ICD编码', trigger: 'change,blur' }],
					hospitalBed: [{ required: true, message: '请输入床位号', trigger: 'blur' }],
					inpatientArea: [{ required: true, message: '请选择病区', trigger: 'change' }],
				},
			},
			form1: {
				orgId: '', // 医院ID
				datasources: '', // 就诊类型
				departmentId: '', // 科室ID
				mainDoctorId: '', // 医生ID
				admissionNumber: '', // 住院号
				hospitalizationTimes: '', // 入院次数
				baseAuxDiagDiscr:'', // 诊断
				inpatientArea:'',
				hospitalBed:'',
				outHospitalTime:'',
				inHospitalTime:'',
				diagnosisList:[],
				patientId:0
			},
			doctorList:[],
			deptList:[],
			mainList:[],
			icd: {
				loading: false,
				value: undefined,
				source: undefined,
				list: undefined,
			},
			addRecordRule:0,
			addLoading:false,
			orgList:[],///本人所属医院
		}
	},
	watch: {
		$route() {
			if (this.$route.query.fid) {
				this.recordId = this.$route.query.fid;
				this.datasources = +this.$route.query.datasources;
				this.loadDetail();
			} else {
				this.recordId = '';
			}
		},
		"form1.datasources"(newValue, oldValue) {
			let id;
			if(newValue == 1){
				id=1
			}else{
				id=0
			}
			this.form1.departmentId='';
			this.form1.mainDoctorId='';
			api.getDeptDropdown({departmentType:id}).then((res)=>{
				if (res.code == 1000 && res.data) {
					this.deptList = res.data;
				}
			})
		},
		"form1.departmentId"(newValue, oldValue) {
			api.getComboboxUserList({ roleId: 2 ,depIds:newValue}).then((res) => {
            if (res.code == 1000 && res.data) {
                this.mainList = res.data;
            }
        })
		},
	},
	created() {
		this.init();
		this.loadNoRead();
		console.log(this.patient,'=====patient')
		this.getControlData();
			
	},
	methods: {
		getControlData(){
			api.getSysRule().then((res) => {
				if (res.code == 1000 && res.data) {
					this.addRecordRule = res.data.add_record.enable==1;
				}
			})
			// 获取科室
			api.getDeptDropdown({departmentType:0}).then((res)=>{
				if (res.code == 1000 && res.data) {
					this.deptList = res.data;
				}
			})
			// 获取 责任医师下拉
			api.getComboboxUserList({ roleId: 2 }).then((res) => {
				if (res.code == 1000 && res.data) {
					this.mainList = res.data;
				}
			})
			this.user = JSON.parse(localStorage.getItem('user')).data.user;
			console.log(this.user,'===user')
			const orgNames = this.user.orgName.split(',');

			const result = this.user.orgIds?.map((id, index) => ({
			value:id,
			label: orgNames[index]
			}));
			this.orgList = result;
		},
		async addRecordHandle(){
			
			this.$refs['form1'].validate(async (valid)=>{
				if (valid) {
					this.addLoading = true;
					
					let list=this.form1.diagnosisList.map(item=>{
						return {
							diagnosisIcd: item.icdCode,
							diagnosisName: item.icdName   
						}
					});
					
					this.form1={
						...this.form1,
						diagnosisList:JSON.stringify(list)
					}
					console.log(this.form1,'====form1');

					let res = await api.addRecord(this.form1);
					this.addLoading = false;
					if (res.code != 1000) {return this.$message.error(res.message);}
					this.$message.success('添加成功');
					this.closeDia()
					this.loadList()
				}
			})
		},
		showDlg(){
			this.form1.diagnosisList=[];
			this.icd.list=[];
			this.form1.inHospitalTime='';
			this.form1.outHospitalTime='';
			this.icd.value=undefined;
			setTimeout(() => {
				this.$refs['form1'].resetFields();
			}, 100);
			this.dlg.active = true;
		},
		async onLoadIcd(query) {
			if (query != '') {
				this.icd.loading = true;
				api.getIdcList({pageSize: 30, param: query}).then((res)=>{
					this.icd.loading = false;
					if (res.code == 1000 && res.data) {
						this.icd.source = res.data;
					}
				});
			}
		},
		onAddIcd() {
			if (this.icd.value) {
				if (!this.icd.list) {
					this.icd.list = [];
				}
				if (!this.icd.list.find(item => { return item.icdId === this.icd.value})) {
					this.icd.list.push(this.icd.source.find(item => { return item.icdId === this.icd.value}));
				}
			}
			this.form1.diagnosisList=this.icd.list;
			this.$refs['form1'].validateField('diagnosisList')
			console.log(this.icd.list,'====icd.list',this.icd.source);
		},
		onRemoveIcd(item) {
			this.icd.list.splice(this.icd.list.findIndex(n => { return n.icdId === item.icdId}), 1);
			this.$refs['form1'].validateField('diagnosisList')
		},
		async init() {
			this.patientId = +this.$route.query.patientId;
			this.filter.patientId = this.patientId;
			this.form1.patientId = this.patientId;
			this.recordId = this.$route.query.fid || 0;
			this.datasources = +this.$route.query.datasources || 0;
			if (+this.$route.query.t2 > 0) {
				this.currentTab = `t${this.$route.query.t2}`;
			}else if(+this.$route.query.t6 > 0){
				this.currentTab = `t${this.$route.query.t6}`;
			}
			this.hospitalCode=await api.getHospitalCode();
			this.emrUrl1=await api.getemrUrl1();
			this.wxQrflag=await api.getWeQrflag();
			let res = await api.getPatient({
					patientId: this.patientId
				});
			this.patientInfo=res.data;
			console.log('patientInfo',this.patientInfo);
			await this.loadList();
			await this.loadDetail();
			setInterval(()=>{
				this.loadNoRead();
			},10000);
		},
		async loadList() {
			this.isLoading = true;
			let res = await api.getFollowUpList(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}

			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.recordTime = dayjs(item.recordTime).format('YYYY-MM-DD');
				})
				this.list.data = res.data;
			}
			this.isLoading = false;
		},
		async loadDetail() {
			if (this.recordId != "") {
				this.isLoading = true;
				let res = await api.getFollowUp({recordId: this.recordId,datasources:this.datasources});
				this.isLoading = false;
				if (res.code != 1000) {
					return this.$message.error(res.message);
				}
				this.itemDetail = res.data;
				console.log(this.itemDetail,'===========iii');
				if(this.hospitalCode=='FJ_SM1'&&window.location.hostname == "jbglxt.smdyyy.cn"){
					this.itemDetail.emrUrl=`http://jbglxt.smdyyy.cn:30080/EmrView/?${this.itemDetail.emrUrl.split('?')[1]}`;
				}
			}
		},
		async loadNoRead() {
			if (this.recordId != "") {
				let user = JSON.parse(localStorage.getItem("user"));
				this.isLoading = true;
				let res = await api.unreadmsg(user.data.user.id);
				this.isLoading = false;
				if (res.code != 1000) {
					return this.$message.error(res.message);
				}
				this.noReadNum = res.data;
			}
		},
		async viewQr(){
			let r=await api.getQrUrl({inHospitalId:this.itemDetail.dataId,datasources:this.itemDetail.datasources});
			if(r.code==1000){
				this.dialogVisible=true;
				this.qrcode(r.data.qrUrl);
			}
		},

		qrcode(url) {
			this.imgData=true;

			this.$nextTick(() => {
				const qrcode = new QRCode(this.$refs.qrcode, {
					text: url,
					width: 230,
					height:230
				});
			});
        },
		
		downloadQRCode() {
			const canvas = this.$refs.qrcode.querySelector('canvas');
			const url = canvas.toDataURL('image/png');
			const link = document.createElement('a');
			link.href = url;
			link.download = 'qrcode.png';
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		closeDia(){
			this.dialogVisible = false;
			this.imgData=false;
			this.dlg.active = false;
		},
		backToList() {
			this.$router.push({name: 'Patient/User', query: {patientId: this.patientId, t:3}});
		},
		handleTab(tab, event) {
			// 点击切换tab的时候刷新数据
			if(tab.name == "t1"){
				this.$refs.info_t1.init();
			}else if(tab.name == "t5"){
				this.$refs.info_t5.init();
			}
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			switch(key) {
				case 0:
					if (this.filter.date) {
						this.filter.recordTimeStart = dayjs(this.filter.date[0]).format('YYYY-MM-DD 00:00:00');
						this.filter.recordTimeEnd = dayjs(this.filter.date[1]).format('YYYY-MM-DD 23:59:59');
					} else {
						this.filter.recordTimeStart = '';
						this.filter.recordTimeEnd = '';						
					}
					break;
			}
			this.filter.pageNumber = 1;
			this.loadList();
		},			
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		},
		openUserFollowup4(t){
			this.currentTab = "t4";
			this.typeT = t;
			// ----滚动
			let tab=document.querySelector('.customize');
			this.$nextTick(()=>{
				tab.scrollIntoView();
				tab.scrollTo(0,200)

			})
		}
	}
}
</script>

<style lang="less" scoped>
@import './user-followup.less';	
</style>
